<template>
  <Icon
    :icon="id"
    :style="style"
    :class="[
      'kvass-icon',
      `kvass-icon--size-${size}`,
      { 'kvass-icon--spin': spin, 'kvass-icon--rotate': rotation },
    ]"
  />
</template>

<script>
import { Icon, addAPIProvider } from '@iconify/vue2'
addAPIProvider('', { resources: ['https://icons.ui.kvass.no'] })

const parseIcon = icon => {
  if (typeof icon === 'string') return { theme: 'fas', icon }
  return { theme: icon.at(0), icon: icon.at(1) }
}

const themeMap = {
  fas: 'fa-pro-solid',
  fal: 'fa-pro-light',
  far: 'fa-pro-regular',
  fab: 'fa-pro-brands',
  fad: 'fa-pro-duotone',
}

export default {
  props: {
    icon: [String, Array],
    spin: Boolean,
    rotation: String,
    size: {
      type: String,
      enums: [
        'default',
        'lg',
        'sx',
        'sm',
        '1x',
        '2x',
        '3x',
        '4x',
        '5x',
        '6x',
        '7x',
        '8x',
        '9x',
        '10x',
      ],
      default: 'default',
    },
  },
  computed: {
    id() {
      if (!this.icon) return

      if (typeof this.icon === 'string' && this.icon.includes(':')) return this.icon // Iconify

      const { theme, icon } = parseIcon(this.icon)
      return `${themeMap[theme]}:${icon}` // Old FA
    },
    style() {
      if (!this.rotation) return
      return `--kvass-icon-rotation: ${this.rotation}deg`
    },
  },
  components: { Icon },
}
</script>

<style lang="scss">
.kvass-icon {
  vertical-align: -0.125em;
  display: inline-block;

  &--rotate {
    rotate: var(--kvass-icon-rotation);
  }

  &--spin {
    animation-name: rotate;
    animation-duration: var(--kvass-icon-spin-duration, 500ms);
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    @keyframes rotate {
      to {
        rotate: 1turn;
      }
    }
  }

  $sizes: (
    'xs': 0.75em,
    'sm': 0.875em,
    'default': 1em,
    'lg': 1.33333em,
  );

  @each $key, $value in $sizes {
    &--size-#{$key} {
      font-size: $value;
    }
  }

  @for $i from 2 through 10 {
    &--size-#{$i}x {
      font-size: $i * 1em;
    }
  }
}
</style>
